<template>
  <div
    v-if="!restrictAccessToTimeLog"
    :id="`js-sidebar-menu-item-timer`"
    :class="[
      $style.menu_item,
      isOpenSideBar ? '' : 'tooltip-gantt',
      'gp_autotest_sidebar_menu_item_timer'
    ]"
    data-position="right"
    data-key="app_footer_btn_tracker_text"
    data-x="9"
    data-y="0"
    @click="timerClick"
  >
    <div :class="[$style.wrapper]">
      <div :class="[$style.menu_icon]">
        <svg-sprite
          name="timer"
          :size="20"
        />
      </div>
      <span
        v-if="isOpenSideBar"
        :class="$style.menu_title"
      >
        <span
          v-if="timerValue"
          class="timer_value"
        >
          {{ timerValue }}
        </span>
        <span v-else>
          {{ locales('app_footer_btn_tracker_text') }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import app from '$$app';
import globalStore from '$$store/main';
import { checkPricingAccess } from '../../../helpers/pricingHelper';
import SvgSprite from '../../common/VueComponents/VueIcon/svgSprite.vue';

export default {
  name: 'TimerButton',
  components: { SvgSprite },
  props: {
    isOpenSideBar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      locales: __,
      appListeners: [],
    };
  },
  computed: {
    restrictAccessToTimeLog() {
      return !checkPricingAccess('time_tracking');
    },
    timerValue() {
      return globalStore.getters['footer/timerValue'];
    },
  },
  mounted() {
    // Слушаем обновления таймера
    this.appListeners.push(
      app.on('updateFooterGlobalTimer', (timer_value) => {
        globalStore.commit('footer/seTimerValue', timer_value);
      })
    );
  },
  beforeUnmount() {
    this.appListeners.forEach(listener => {
      if (listener && typeof listener.detach === 'function') {
        listener.detach();
      }
    });
    this.appListeners = [];
  },
  methods: {
    timerClick() {
      if (this.restrictAccessToTimeLog) {
        return;
      }
      const pos = this.$el.getBoundingClientRect();
      app.trigger('showTimeTrackingPopup', 'global', pos);
    },
  },
};
</script>

<style module src="../style.less" lang="less"></style>
<style scoped lang="less">
.timer_value {
  font-weight: 500;
  color: #216DC3;
}
</style>
